import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';

import { LogoutComponent } from './logout.component';

/**
 * @name LogoutModule
 *
 * @ngdoc module
 */
@NgModule({
    declarations: [LogoutComponent],
    exports: [LogoutComponent],
    imports: [ApButtonComponent, ApContentModule, CommonModule]
})
export class LogoutModule {}
